import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_2 = { class: "px-[34px] icon flex justify-center mb-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex w-[34px] min-w-[34px] items-center justify-center cursor-pointer" }
const _hoisted_6 = { class: "flex items-center justify-between mb-4" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex justify-between mb-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  id: "popover-button",
  class: "flex items-center justify-center rounded-lg font-sourcesanspro-bold text-anykrowd-dark text-md cursor-pointer"
}
const _hoisted_12 = { class: "mr-2" }
const _hoisted_13 = { class: "mr-2" }
const _hoisted_14 = { class: "flex flex-col px-3 py-2 font-sourcesanspro-regular" }
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = {
  key: 2,
  class: "w-full flex justify-center font-sourcesanspro-bold text-anykrowd-dark text-md pt-4"
}
const _hoisted_17 = { class: "flex items-center mb-4" }
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = {
  key: 0,
  class: "font-sourcesanspro-black text-l2 font-color-dark leading-none"
}
const _hoisted_20 = {
  key: 1,
  class: "font-sourcesanspro-regular text-base font-color-dark leading-none"
}
const _hoisted_21 = { class: "flex items-center justify-between" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = {
  key: 1,
  class: "flex items-baseline"
}
const _hoisted_24 = { class: "mr-1" }
const _hoisted_25 = { class: "font-sourcesanspro-black text-lg3 font-color-dark" }
const _hoisted_26 = { class: "font-sourcesanspro-regular text-md font-color-dark" }
const _hoisted_27 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_28 = { class: "mr-2" }
const _hoisted_29 = {
  key: 0,
  class: "flex flex-col font-sourcesanspro-semibold text-anykrowd-dark/50 text-sm mb-6 mt-4"
}
const _hoisted_30 = { class: "flex w-[34px] min-w-[34px] items-center justify-center cursor-pointer" }

import { onMounted, ref, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { IonContent, IonButton, IonIcon, IonItem, IonList, IonPopover, IonSpinner } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { addOutline, chevronBackOutline, chevronDownOutline, chevronForwardOutline } from 'ionicons/icons';

import TopBar from '@/shared/components/TopBar.vue';
import BackButton from '@/shared/components/BackButton.vue';
import { useAssetsStore } from '@/stores/shared/assetsStore';
import useRfidGuest from '@/modules/rfid/composables/useRfidGuest';
import useTenant from '@/shared/composables/useTenant';
import { captureMessage } from '@/sentry';
import { Wallet } from '@/shared/interfaces/balance';


export default /*@__PURE__*/_defineComponent({
  __name: 'RfidGuestTopupPage',
  setup(__props) {

const { t } = useI18n();
const assetStore = useAssetsStore();
const router = useRouter();
const route = useRoute();

const encryptedRfidTag = route.params.id?.toString?.() || '';
const { searchRfidTag } = useRfidGuest();
const { isSuccessRfidTag, rfidTag, rfidTagMutate } = searchRfidTag();
const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig } = getTenantConfigAndStyles();

const selectedWallet = ref<Wallet | undefined>();
const wallets = ref();

onMounted(async () => {
	if (encryptedRfidTag) {
		rfidTagMutate({ encrypted_rfid_tag: encryptedRfidTag });
	}
});

watchEffect(() => {
	wallets.value = rfidTag.value?.wallets;

	if (wallets.value && wallets.value.length && wallets.value.length > 0) {
		if (!selectedWallet.value) {
			selectedWallet.value = wallets.value.find((wallet: Wallet) => {
				return wallet.currency.default;
			});

			if (!selectedWallet.value && wallets.value.length > 0) {
				selectedWallet.value = wallets.value[0];
			}
		}
	}
});

const selectWallet = (wallet: Wallet | undefined) => {
	if (!wallet) {
		captureMessage(`Attempted to select a wallet that does not exist`);
	}
	selectedWallet.value = wallet;
};

const getWalletAtIndex = (index: number) => {
	if (index >= wallets.value!.length) {
		index = 0;
	} else if (index < 0) {
		index = wallets.value!.length - 1;
	}
	return wallets.value?.[index];
};

const currentWalletIndex = () => {
	return wallets.value!.findIndex((wallet: Wallet) => wallet.id === selectedWallet.value!.id);
};

const getPreviousWallet = () => {
	return getWalletAtIndex(currentWalletIndex() - 1);
};

const getNextWallet = () => {
	return getWalletAtIndex(currentWalletIndex() + 1);
};

const selectPreviousWallet = () => {
	selectWallet(getPreviousWallet());
};

const selectNextWallet = () => {
	selectWallet(getNextWallet());
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(TopBar, { class: "px-[34px]" }, {
        left: _withCtx(() => [
          _createVNode(BackButton, { to: "/dashboard" })
        ]),
        center: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('guest_top_up.title')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(assetStore).logoUrl,
            class: "max-w-[70%]"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (wallets.value && wallets.value?.length > 1)
              ? (_openBlock(), _createBlock(_unref(IonIcon), {
                  key: 0,
                  icon: _unref(chevronBackOutline),
                  class: "text-white active:bg-white/30 active:rounded-full active:p-1",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (selectPreviousWallet()))
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["flex w-full flex-col justify-between px-3 bg-white rounded-xl mb-2", _unref(rfidTag) ? 'py-3' : 'pt-3'])
          }, [
            _createElementVNode("div", _hoisted_6, [
              (_unref(rfidTag))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: require('@/statics/svg/rfid/bracelet-with-bg.svg'),
                    height: "34",
                    width: "34"
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              (_unref(rfidTag))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1)),
                      (selectedWallet.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, _toDisplayString(selectedWallet.value.currency.prefix), 1),
                              _createElementVNode("div", _hoisted_13, _toDisplayString(selectedWallet.value?.currency.name), 1),
                              (_unref(rfidTag)?.wallets && _unref(rfidTag)?.wallets?.length > 1)
                                ? (_openBlock(), _createBlock(_unref(IonIcon), {
                                    key: 0,
                                    icon: _unref(chevronDownOutline),
                                    class: "text-anykrowd-dark text-md"
                                  }, null, 8, ["icon"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_unref(IonPopover), {
                              trigger: "popover-button",
                              "dismiss-on-select": true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonContent), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonList), null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rfidTag)?.wallets, (wallet) => {
                                          return (_openBlock(), _createBlock(_unref(IonItem), {
                                            class: "flex items-center justify-center ion-no-padding ion-no-margin",
                                            key: wallet.id,
                                            button: true,
                                            onClick: ($event: any) => (selectWallet(wallet)),
                                            detail: false
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("div", _hoisted_15, [
                                                  _createElementVNode("span", null, _toDisplayString(wallet.currency.prefix) + " " + _toDisplayString(wallet.current_balance) + " " + _toDisplayString(wallet.currency.name), 1)
                                                ])
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_unref(rfidTag) && _unref(isSuccessRfidTag))
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(t)('guest_top_up.not_found')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                (_unref(rfidTag))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(rfidTag).user ? `${_unref(rfidTag).user.firstname} ${_unref(rfidTag).user.lastname}` : `${_unref(t)('rfid.guest.wallet')} #${selectedWallet.value?.id}`), 1))
                  : _createCommentVNode("", true),
                (_unref(rfidTag))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(rfidTag).uuid), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                (!_unref(isSuccessRfidTag) && !_unref(tenantConfig))
                  ? (_openBlock(), _createBlock(_unref(IonSpinner), {
                      key: 0,
                      name: "dots",
                      class: "spinner-black"
                    }))
                  : _createCommentVNode("", true),
                (selectedWallet.value && _unref(tenantConfig))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(selectedWallet.value?.currency.prefix) + _toDisplayString(selectedWallet.value?.current_balance), 1)
                      ]),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(selectedWallet.value.currency.suffix), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (selectedWallet.value && selectedWallet.value!.currency.topupable == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_unref(IonButton), {
                      class: "w-[117px] h-[40px] black font-sourcesanspro-semibold text-sm2 ion-no-margin",
                      shape: "round",
                      routerLink: `/top-up/${selectedWallet.value?.id}?id=${_unref(encryptedRfidTag)}`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"])
                        ]),
                        _createTextVNode(" " + _toDisplayString(_unref(t)('rfid.guest.add')), 1)
                      ]),
                      _: 1
                    }, 8, ["routerLink"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (selectedWallet.value && selectedWallet.value.currency?.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(selectedWallet.value.currency?.description), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_30, [
            (wallets.value && wallets.value?.length > 1)
              ? (_openBlock(), _createBlock(_unref(IonIcon), {
                  key: 0,
                  icon: _unref(chevronForwardOutline),
                  class: "text-white active:bg-white/30 active:rounded-full active:p-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (selectNextWallet()))
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})